import React, { useRef } from "react";
import PropTypes from "prop-types";
import "./Input.scss";
import { Font } from "../Fonts/Font";
import { useState } from "react";
import { useSelector } from "react-redux";

export const Type = {
  WITH_ICON: "with-icon",
  TEXT: "text",
  EMAIL: "email",
  PASSWORD: "password",
  LABEL_TEXT: "label_text",
  LABEL_EMAIL: "label_email",
  LABEL_PASSWORD: "label_password",
  CHECKBOX: "checkbox",
  FILE: "file",
  RADIO: "radio",
  SELECT: "select",
  TEXTAREA: "textarea",
  NUMBER: "number",
};

export const Input = ({
  placeholder,
  icon,
  background,
  border,
  color,
  height,
  size,
  link,
  inputSize,
  label,
  name,
  type,
  isChange,
  width,
  disabled,
  checked,
  onChange,
  allowMultiple,
  ref,
  maxLength,
  minLength,
  min,
  max,
  value,
  onBlur,
  onClick,
  notSellerReg,
  readOnly,
  onKeyDown,
  pattern,
  remove,
  ...props
}) => {
  const hiddenFileInput = useRef(null);
  const [activeLink, setActiveLink] = useState("#");
  const [showFile, setShowFile] = useState(true);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  ref = hiddenFileInput
  // const handleFileChange = () => {
  //   setShowFile(false);
  //   props.onChange();
  // };
  const order = useSelector((el) => el?.checkout);


  if (type === Type.WITH_ICON) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <Font label={label} size={14} color="#292929" weight={600} />
        <div style={{ width: width, position: "relative" }}>
          <input
            required
            type={"text"}
            placeholder={placeholder}
            style={{ width: width }}
            onChange={onChange}
            value={value}
            name={name}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
          />
          <img src={icon} alt={"es-input"} onClick={onClick} />
        </div>
      </div>
    );
  } else if (type === Type.TEXTAREA) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <textarea
          style={{ padding: "10px" }}
          name=""
          rows={10}
          id=""
          value={value}
          onChange={onChange}
        ></textarea>
      </div>
    );
  } else if (type === Type.NUMBER) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <Font label={label} size={14} color="#292929" weight={600} />
        <div style={{ width: width, position: "relative" }}>
          <input
            required
            type={"number"}
            placeholder={placeholder}
            style={{ width: width, color: color, border: border }}
            onChange={onChange}
            value={value}
            name={name}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            min={min}
            max={max}
          />
        </div>
      </div>
    );
  } else if (type === Type.PASSWORD) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <input
          multiple={allowMultiple}
          required
          type={"password"}
          placeholder={placeholder}
          style={{ width: width }}
          onChange={onChange}
          value={value}
          name={name}
          onBlur={onBlur}
        />
      </div>
    );
  } else if (type === Type.EMAIL) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <input
          multiple={allowMultiple}
          required
          type={"email"}
          placeholder={placeholder}
          style={{ width: width }}
          onChange={onChange}
          value={value}
          name={name}
          onBlur={onBlur}
        />
      </div>
    );
  } else if (type === Type.FILE) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <Font label={label} size={14} color={color} weight={600} />
        <div
          className="diff"
          style={{
            width: width + "px",
            height: height + "px",
            background: background,
            display: "flex",
            border: " 1px solid #969595",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <button type={"button"} onClick={handleClick} disabled={disabled}>
            {isChange ? "Change Image" : "Add Image"}
          </button>

          {showFile && notSellerReg ? (
            <input
              multiple={allowMultiple}
              required
              type={"file"}
              placeholder={placeholder}
              ref={ref}
              size={inputSize}
              onChange={onChange}
              style={{
                display: "none",
              }}
            />
          ) : (
            <input
              required
              type={"file"}
              ref={ref}
              placeholder={placeholder}
              size={inputSize}
              onChange={onChange}
            />
          )}
        </div>
      </div>
    );
  } else if (type === Type.SELECT) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <input
          multiple={allowMultiple}
          required
          type={"select"}
          placeholder={placeholder}
          style={{ width: width }}
          onChange={onChange}
          value={value}
          name={name}
          onBlur={onBlur}
          readOnly
        />
      </div>
    );
  } else if (type === Type.LABEL_EMAIL) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <Font label={label} size={14} color="#292929" />
        <input
          multiple={allowMultiple}
          required
          type={"email"}
          placeholder={placeholder}
          style={{ width: width }}
          onChange={onChange}
          pattern={pattern}
          value={value}
          name={name}
          onBlur={onBlur}
        />
      </div>
    );
  } else if (type === Type.LABEL_PASSWORD) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <Font label={label} size={14} color="#292929" />
        <input
          multiple={allowMultiple}
          required
          type={"password"}
          placeholder={placeholder}
          style={{ width: width }}
          onChange={onChange}
          value={value}
          name={name}
          onBlur={onBlur}
        />
      </div>
    );
  } else if (type === Type.LABEL_TEXT) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <Font label={label} size={14} color="#292929" />
        <input
          multiple={allowMultiple}
          required
          type={"text"}
          pattern={pattern}
          placeholder={placeholder}
          style={{ width: width, color: color, border: border }}
          onChange={onChange}
          value={value}
          name={name}
          onBlur={onBlur}
          readOnly={readOnly}
          minLength={minLength}
          maxLength={maxLength}
          onKeyDown={onKeyDown}
        />
      </div>
    );
  } else if (type === Type.RADIO) {
    return (
      <div className={[`${type}`, "es-custom-input"].join(" ")}>
        <input
          multiple={allowMultiple}
          required
          type={"radio"}
          style={{ width: width }}
        />
      </div>
    );
  } else if (type === Type.CHECKBOX) {
    return (
      <div className={[`${type}`, "es-custom-"].join(" ")}>
        <input
          multiple={allowMultiple}
          type="checkbox"
          checked={checked}
          onClick={onClick}
          style={{ width: width }}
        />
      </div>
    );
  } else {
    return (
      <div className={[`text`, "es-custom-input"].join(" ")}>
        <input
          multiple={allowMultiple}
          required
          type={type}
          placeholder={placeholder}
          style={{ width: width }}
          onChange={onChange}
          value={value}
          name={name}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
        />
      </div>
    );
  }
};

Input.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  checked: PropTypes.bool,
  type: PropTypes.oneOf([
    Type.SEARCH,
    Type.PASSWORD,
    Type.TEXT,
    Type.EMAIL,
    Type.CHECKBOX,
    Type.RADIO,
    Type.SELECT,
  ]),
};

Input.defaultProps = {
  label: " ",
  placeholder: "",
  type: Type.Text,
  checked: false,
  notSellerReg: true,
};
